import { Exclude, Type } from 'class-transformer';

export class ConveyanceClosingPaperCommunitiesResultDto {
    communityId: number;
    communityName: string;

    @Type(() => Date)
    conveyanceDate: Date;

    /**
     * Conveyance status. Values --> REVERSED, SCHEDULED, SUCCESS
     */
    conveyanceStatus: string;

    // Transient variable
    @Exclude()
    isChecked: boolean;
}
